export const joinUrls = (...urls: string[]): string => {
  if (urls.length === 0) return '';

  return urls
    .map((url, index) => {
      // Trim trailing slashes for all but the last URL
      if (index < urls.length - 1) {
        url = url.replace(/\/+$/, '');
      }
      // Ensure leading slashes for relative URLs
      if (!url.startsWith('http') && !url.startsWith('/')) {
        url = '/' + url;
      }
      return url;
    })
    .join('');
};
